<ng-container *ngIf="isLoading; else pageContent">
<div class="app-spinner">
	<mat-spinner></mat-spinner>
</div>
</ng-container>

<ng-template #pageContent>
    <div class="student-results-container">
      <div class="header-section" *ngIf="_fullStudentQuizResult">
        <div class="quiz-info">
          <div class="title-row">
            <i class="bi bi-arrow-left-short" (click)="goToBack()"></i>
            <h3 class="quiz-title">{{_fullStudentQuizResult.quiz_name}}</h3>
          </div>
          <p class="published-date"><i class="bi bi-calendar"></i>
            {{convertToIST(_fullStudentQuizResult.published_date) }}</p>
        </div>
        <div class="average-score">
          <span class="score-value">{{_fullStudentQuizResult.averageScore}}</span>
          <span class="score-label">Average Score</span>
        </div>
      </div>


       <div class="top-scorers-wrapper" *ngIf="topPerformers.length > 0">
        <h2 class="heading">Top Scores</h2>

        <div class="podium-wrapper">

          <div class="podium-item podium-2" *ngIf="secondRank">
            <div class="icon-circle">
              <i class="bi bi-award-fill"></i>
            </div>

            <div class="podium-block block-2">
              <p class="name">{{ secondRank.name }}</p>
              <p class="percent">{{ secondRank.score }}</p>
              <div class="rank-number">2</div>
            </div>
          </div>

          <div class="podium-item podium-1" *ngIf="firstRank">
            <div class="icon-circle">
              <i class="bi bi-trophy-fill"></i>
            </div>

            <div class="podium-block block-1">
              <p class="name">{{ firstRank.name }}</p>
              <p class="percent">{{ firstRank.score }}</p>
              <div class="rank-number">1</div>
            </div>
          </div>

          <div class="podium-item podium-3" *ngIf="thirdRank">
            <div class="icon-circle">
              <i class="bi bi-award"></i>
            </div>

            <div class="podium-block block-3">
              <p class="name">{{ thirdRank.name }}</p>
              <p class="percent">{{ thirdRank.score }}</p>
              <div class="rank-number">3</div>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="topPerformers.length === 0" class="no-top-performers text-center mt-2">
        No top performers yet.
      </div> 






  <div class="filter-section">
    <label class="result">Students Results</label>

    <div class="filter-controls">
      <label for="filter" class="filter-label">Filter by:</label>
      <select id="filter" class="filter-dropdown" (change)="onFilterChange($event)" [(ngModel)]="filterValue">
    <option [value]="_QuizResultFilterType.All">All Students</option>
    <option [value]="_QuizResultFilterType.Submitted">Submitted Only</option>
    <option [value]="_QuizResultFilterType.AutoSubmitted">Auto Submitted</option>
    <option [value]="_QuizResultFilterType.NotSubmitted">Not Submitted</option>
    <option [value]="_QuizResultFilterType.Inprogress">In Progress</option>
      </select>
    </div>
  </div>

      <table class="results-table">
        <thead>
          <tr>
            <th>No.</th>
            <th>Student Name</th>
            <th>Status</th>
            <th>Score</th>
            <th>Time Taken</th>
            <th>Attempt Date</th>
            <th>View Response</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let studentQuiz of _paginatedStudents; let i = index">
            <td>{{ first + i + 1 }}</td>
            <td>{{ studentQuiz.name }}</td>
            <td>
              <span class="status-badge" [ngClass]="{
        'submitted': studentQuiz.status.toLowerCase() === 'submitted',
        'not-submitted': studentQuiz.status.toLowerCase() === 'not submitted'
      }">
                {{ studentQuiz.status }}
              </span>
            </td>
            <td>{{ studentQuiz.score || '-' }}</td>
            <td>{{ formatTime(studentQuiz?.attempt_data?.time_taken) }}</td>
            <td>{{ studentQuiz.finished_at |date :'d MMM y'}}</td>
            <td>
              <button class="view-btn" (click)="goToStudentResultPage(studentQuiz.attempt_data.attempt_id)">
                <i class="bi bi-eye"></i> View</button>
            </td>
          </tr>
        </tbody>
      </table>

      <div class="pagination-section mt-1">
      <ng-container *ngIf="_paginatedStudents && _paginatedStudents.length > 0; else noDataMessage">
    <div class="pagination card flex justify-center">
      <p-paginator
        [first]="first"
        [rows]="rows"
        [totalRecords]="_totalRecords"
        [rowsPerPageOptions]="[10, 20, 30, 50, 100]"
        (onPageChange)="onPageChange($event)">
      </p-paginator>
    </div>
  </ng-container>

  <ng-template #noDataMessage>
    <div class="no-top-performers text-center mt-2">
      <i class="bi bi-emoji-frown fs-5 d-block mb-1"></i>
      <p class="m-0 text-muted">No students found for this filter.</p>
    </div>
  </ng-template>
</div>
</div>
</ng-template>